import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class SelectableStylingModel extends CoreStylingModel {
/**
 * Styling object for button (Angular Material checkbox, radio-button or slide-toggle)
 */
button?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectableStylingModel_tsickle_Closure_declarations() {
/**
 * Styling object for button (Angular Material checkbox, radio-button or slide-toggle)
 * @type {?}
 */
SelectableStylingModel.prototype.button;
}

